// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"ffd1b375","712":"fe816886","758":"55f03a29","810":"9be14fb7"}[chunkId] + ".chunk.js";
};